<script>
  import SectionTitle from "../../layout/SectionTitle.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import GithubLikeButton from "../../button/GithubLikeButton.svelte";
  import { getContext, tick } from "svelte";
  import DeleteConfirmationDialog from "../../DeleteConfirmationDialog.svelte";
  import { reset } from "../../../utils/putData.js";
  import {FetchError} from "../../../utils/getData.js";
  import {getNotificationsContext} from "svelte-notifications";
  import SectionCaption from "../../layout/SectionCaption.svelte";

  /**
   * @type {string}
   */
  export let projectId

  const {handleNonBlockingFetchErrors} = getContext("fetchErrorHandler")
  const {addNotification} = getNotificationsContext()

  // delete confirmation dialog related things
  let deleteConfirmationDialog
  let isDeleteConfirmationDialogOpen = false
  let deleteConfirmationDialogProps = {
    title: null,
    message: null,
    onConfirmed: () => {},
  }

  async function openDeleteConfirmationDialog(dialogProps) {
    isDeleteConfirmationDialogOpen = true
    deleteConfirmationDialogProps = dialogProps
    await tick()
    deleteConfirmationDialog.showModal()
  }

  function closeDeleteConfirmationDialog() {
    deleteConfirmationDialog.close()
    deleteConfirmationDialogProps = null
    isDeleteConfirmationDialogOpen = false
  }

  /**
   *
   * @param {"result"|"bomEdit"} type
   * @param {string} successMessage
   */
  async function deleteTransactions(type, successMessage) {
    let folderName
    try {
      switch (type) {
        case "result":
          folderName = "Result"
          break
        case "bomEdit":
          folderName = "IntegratedMaster"
          break
        default:
          throw new Error(`UNEXPECTED TYPE ${type}`)
      }
      await reset(projectId, folderName)
      addNotification({
        type: "success",
        text: successMessage,
        position: "top-right",
        removeAfter: 3000
      })
      deleteConfirmationDialog.close()
    } catch (e) {
      if (e instanceof FetchError) {
        handleNonBlockingFetchErrors(e.error)
      } else {
        addNotification({
          type: "error",
          text: translate("generic.removeFailed"),
          position: "top-right",
          removeAfter: 3000
        })
      }
    }
  }
</script>

<SectionTitle title={translate("frontend:pages:projects.project.admin.sections.transactions.title")}/>
<SectionCaption>
  {translate("frontend:pages:projects.project.admin.sections.transactions.caption")}
</SectionCaption>
<div style="display: flex; flex-direction: column; gap: 1rem; padding: 1rem;">
  <hr style="width: 100%; background-color: darkgray; height: 1px; border: none"/>
  <div class="section">
    <div style="flex: 1">
      {translate("frontend:pages:projects.project.admin.sections.transactions.deleteResultTransactions.title")}
      <div class="caption">
        {translate("frontend:pages:projects.project.admin.sections.transactions.deleteResultTransactions.caption")}
      </div>
    </div>
    <div>
      <GithubLikeButton
        type="button"
        color="gray-alert"
        label={translate("generic.remove")}
        onClick={() => {
          openDeleteConfirmationDialog({
            title: translate("frontend:pages:projects.project.admin.sections.transactions.deleteResultTransactions.deleteConfirmation.title"),
            message: translate("frontend:pages:projects.project.admin.sections.transactions.deleteResultTransactions.deleteConfirmation.message"),
            onConfirmed: () => deleteTransactions("result", translate("frontend:pages:projects.project.admin.sections.transactions.deleteResultTransactions.deleteConfirmation.deleteSuccessMessage")),
          })
        }}
      />
    </div>
  </div>
  <hr style="width: 100%; background-color: darkgray; height: 1px; border: none"/>
  <div class="section">
    <div style="flex: 1">
      {translate("frontend:pages:projects.project.admin.sections.transactions.deleteBomEditTransactions.title")}
      <div class="caption">
        {translate("frontend:pages:projects.project.admin.sections.transactions.deleteBomEditTransactions.caption")}
      </div>
    </div>
    <div>
      <GithubLikeButton
        type="button"
        color="gray-alert"
        label={translate("generic.remove")}
        onClick={() => openDeleteConfirmationDialog({
          title: translate("frontend:pages:projects.project.admin.sections.transactions.deleteBomEditTransactions.deleteConfirmation.title"),
          message: translate("frontend:pages:projects.project.admin.sections.transactions.deleteBomEditTransactions.deleteConfirmation.message"),
          onConfirmed: () => deleteTransactions("bomEdit", translate("frontend:pages:projects.project.admin.sections.transactions.deleteBomEditTransactions.deleteConfirmation.deleteSuccessMessage")),
        })}
      />
    </div>
  </div>
</div>
{#if isDeleteConfirmationDialogOpen}
  <DeleteConfirmationDialog
    bind:dialog={deleteConfirmationDialog}
    onClose={closeDeleteConfirmationDialog}
    title={deleteConfirmationDialogProps.title}
    message={deleteConfirmationDialogProps.message}
    onConfirmed={() => deleteConfirmationDialogProps.onConfirmed()}
  />
{/if}

<style>
  .caption {
    font-size: 0.9rem;
  }

  .section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }
</style>

